import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useWorkspaceTodoEditSetBodyMutation } from "./__generated__/useWorkspaceTodoEditSetBodyMutation.graphql";
import { SetStatusFN } from "./statusCoordinator";
import { useDebouncedMutation } from "../../../../../common/Utils/useDebouncedMutation";

const key = "set_body";
export function useTodoEditSetBody(
  id: string,
  remoteBody: {
    body: string;
    formattedBody: string | null;
  },
  setStatus: SetStatusFN
) {
  const [updateBody, loading] =
    useMutation<useWorkspaceTodoEditSetBodyMutation>(graphql`
      mutation useWorkspaceTodoEditSetBodyMutation(
        $id: ID!
        $body: String!
        $formattedBody: String
      ) {
        todoWorkspace(id: $id) {
          updateBody(newBody: $body, newFormattedBody: $formattedBody) {
            id
            updatedBySessionId
            body
            formattedBody

            ...WorkspaceTodoEditMainEditedInfo_Todo
            ...WorkspaceTodoEditMainProducts_TodoWorkspace
          }
        }
      }
    `);

  const saveBody = useCallback(
    (args: { body: string; formattedBody: string | null }) =>
      updateBody({
        onError: () => setStatus(key, "error"),
        onCompleted: () => setStatus(key, "saved"),
        variables: {
          id,
          body: args.body,
          formattedBody: args.formattedBody,
        },
      }),
    [id, setStatus, updateBody]
  );

  return [
    ...useDebouncedMutation(
      remoteBody,
      saveBody,
      undefined,
      {
        getValueKey: ({ body, formattedBody }) =>
          formattedBody ? formattedBody : "___EMPTY___",
      },
      () => setStatus(key, "saving")
    ),
    loading,
  ] as const;
}
